import { Button, DatePicker, Form, Select, Space, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import { ConfirmDeletingElement, CustomInputNumber } from '@app/components';
import {
  DATE_PICKER_FORMAT,
  OFF,
  PREFIX,
  RULES_IS_REQUIRE,
} from '@app/constants';
import {
  useAddPaymentDocument,
  useAddPaymentDocumentsEffects,
} from '@app/pages/PaymentDocuments/components/AddPaymentDocument/hooks';

const { Text } = Typography;

export const AddPaymentDocument = () => {
  const {
    form,
    handleSaveDocument,
    isPageLoading,
    mapDictionaryToSelectOptions,
    handleSearchFilters,
    filters,
    isSaving,
    getDocument,
    navigateToRegistry,
    documentId,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    openDeleteDocumentModal,
    deleteDocumentHandler,
  } = useAddPaymentDocument();

  useAddPaymentDocumentsEffects({ handleSearchFilters, getDocument });

  return (
    <div className={`${PREFIX}add-payment-document`}>
      <Form
        form={form}
        onFinish={handleSaveDocument}
        className="bc-form"
        autoComplete={OFF}
      >
        <Space direction="vertical" size="middle">
          <div className="field-container">
            <Text className="label-require" strong>
              Тип документа (пока поддерживается только один тип)
            </Text>
            <Form.Item
              name="DocumentType"
              className="mg-0"
              initialValue="invoice-payment"
              rules={RULES_IS_REQUIRE}
            >
              <Select
                size="large"
                maxLength={200}
                disabled
                loading={isPageLoading}
                options={mapDictionaryToSelectOptions(
                  filters?.DocumentTypes || {}
                )}
              />
            </Form.Item>
          </div>
          <div className="field-container">
            <Text className="label-require" strong>
              Организация
            </Text>
            <Form.Item
              name="OrganizationId"
              className="mg-0"
              initialValue=""
              rules={RULES_IS_REQUIRE}
            >
              <Select
                size="large"
                loading={isPageLoading}
                maxLength={200}
                options={mapDictionaryToSelectOptions(
                  filters?.Organizations || {}
                )}
              />
            </Form.Item>
          </div>
          <div className="field-container">
            <Text className="label-require" strong>
              Дата создания
            </Text>
            <Form.Item
              name="Timestamp"
              className="mg-0"
              initialValue=""
              rules={RULES_IS_REQUIRE}
            >
              <DatePicker size="large" format={DATE_PICKER_FORMAT} />
            </Form.Item>
          </div>
          <div className="field-container">
            <Text className="label-require" strong>
              Сумма
            </Text>
            <Form.Item
              name="Amount"
              className="mg-0"
              initialValue=""
              rules={RULES_IS_REQUIRE}
            >
              <CustomInputNumber
                className="required-field"
                size="large"
                inputValue={form.getFieldValue('Amount')}
                isAllowed={(floatValue: number) => floatValue >= 0.01}
                onSuccess={({ value }) => {
                  form.setFieldValue('Amount', value);
                }}
              />
            </Form.Item>
          </div>
          <div className="field-container">
            <Text className="label-require" strong>
              Статус
            </Text>
            <Form.Item
              name="Status"
              className="mg-0"
              initialValue=""
              rules={RULES_IS_REQUIRE}
            >
              <Select
                size="large"
                maxLength={200}
                loading={isPageLoading}
                options={mapDictionaryToSelectOptions(filters?.Statuses || {})}
              />
            </Form.Item>
          </div>
          <div className="field-container textarea-container">
            <Text strong>Примечание</Text>
            <Form.Item className="mg-0" name="Comment">
              <TextArea rows={4} maxLength={5000} />
            </Form.Item>
          </div>

          <div className={`${PREFIX}create-warehouse_buttons`}>
            <Button
              type="primary"
              htmlType="submit"
              className={`${PREFIX}create-warehouse_buttons_item`}
              disabled={isPageLoading}
              loading={isSaving}
              size="large"
            >
              Сохранить
            </Button>
            <Button
              type="default"
              className={`${PREFIX}create-warehouse_buttons_item`}
              onClick={navigateToRegistry}
              disabled={isSaving}
              size="large"
            >
              Отменить
            </Button>
            {documentId > 0 && (
              <Button
                danger
                className={`${PREFIX}create-warehouse_buttons_item`}
                disabled={isSaving}
                size="large"
                onClick={openDeleteDocumentModal}
              >
                Удалить
              </Button>
            )}
          </div>
        </Space>
      </Form>
      <ConfirmDeletingElement
        modalOpen={isDeleteModalOpen}
        setModalOpen={setIsDeleteModalOpen}
        handleDelete={deleteDocumentHandler}
        content="Вы уверены, что хотите удалить счёт?"
        title="Удаление счёта"
      />
    </div>
  );
};
